import { MenuConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

// 转让权限
export const transferAuth = appConfigInstance.getConfig(ToolbarFileMenuConfig.transferAuth as any) ?? true;
// 权限设置
export const authMenu = appConfigInstance.getConfig(ToolbarFileMenuConfig.authMenu as any) ?? true;
// 私有化权限设置
export const usePrivateAuthMenu = appConfigInstance.getConfig(ToolbarFileMenuConfig.usePrivateAuthMenu as any) ?? false;

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: ActionType.PERMISSION_MENU,
        content: i18n.t<string>('权限设置'),
        preventDismiss: true,
        respectOffline: true,
    },
    {
        name: ActionType.PERMISSION_SETTING,
        content: usePrivateAuthMenu ? i18n.t<string>('权限管理') : i18n.t<string>('文档权限'),
    },
    {
        name: ActionType.ADVANCED_PERMISSION,
        content: i18n.t<string>('高级权限'),
    },
    {
        name: ActionType.SET_WATER_MARK,
        content: i18n.t<string>('设置文档水印'),
    },
    {
        name: ActionType.TRANSFER_OWNERSHIP,
        content: i18n.t<string>('转让文档所有权'),
    },
];
